import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import '@/assets/css/reset.css';
import less from 'less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(less)
Vue.use(ElementUI);
Vue.config.productionTip = false;
import {
    data
} from '@/utils/data.js';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import BaiduMap from 'vue-baidu-map'
import vueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as filters from './utils/filters.js'
// Vue.use(vueQuillEditor)
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
import {
    getmenu
} from '@/api/axios'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts


// import VCharts from 'v-charts'

// Vue.use(VCharts)


Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.directive('required', {
    componentUpdated: function (el, value, binding) {
        if (el.getElementsByTagName('input')[0]) {
            el.getElementsByTagName('input')[0].onblur = function () {
                if (el.getElementsByTagName('input')[0].value.split(" ").join("").length === 0) {
                    // el.getElementsByTagName('input')[0].focus();
                    el.getElementsByTagName('input')[0].setAttribute('placeholder', '此项为必填项');
                }
            };
        }
        if (el.getElementsByTagName('textarea')[0]) {
            el.getElementsByTagName('textarea')[0].onblur = function () {
                if (el.getElementsByTagName('textarea')[0].value.split(" ").join("").length === 0) {
                    el.getElementsByTagName('textarea')[0].setAttribute('placeholder', '此项为必填项');
                }
            };
        }

    }
});

Vue.directive('requiredNum', {
    componentUpdated: function (el, value, binding) {
        el.getElementsByTagName('input')[0].onblur = function () {
            if (el.getElementsByTagName('input')[0].value.split(" ").join("").length > 0) {
                if (isNaN(el.getElementsByTagName('input')[0].value.split(" ").join("") * 1)) {
                    el.getElementsByTagName('input')[0].value = '';
                    el.getElementsByTagName('input')[0].setAttribute('placeholder', '此项要求为数字');
                }
            }
        };
    }
});



Vue.directive('limitNumber', {
    bind: function (el, binding) {
        let integer = binding.value.integer || 1; //整数位
        let decimal = binding.value.decimal || 0; //小数位
        let allowZero = binding.value.allowZero || false //是否允许为0
        let input;

        if (el.tagName == 'DIV') {
            input = el.getElementsByTagName('input')[0];
        } else {
            input = el;
        }

        input.oninput = function (e) {
            if (!e.isTrusted) {
                return
            }
            let value = input.value;
            let oldValue = input.$oldValue;
            if (!oldValue) {
                oldValue = '';
            }
            let regex;
            let allowZeroStr = allowZero ? 0 : 1;
            if (decimal < 1) {
                regex = new RegExp(`^[${allowZeroStr}-9]\\d{0,${integer - 1}}$`);
            } else {
                regex = new RegExp(`^(([${allowZeroStr}-9]{1}\\d{0,${integer - 1}})|([0]{1}))(\\.(\\d){0,${decimal}})?$`);
            }
            if (regex.test(value) || value == '') {
                input.value = value;
                input.$oldValue = value;
            } else {
                input.value = oldValue;
            }
            input.dispatchEvent(new Event('input'));
        }
    }

})


Vue.directive('hasbtn', {
    modifiers: {
        flag: false,
    },
    componentUpdated: function (el, value, binding) {
        // console.log(el,value,binding)
        // 这里将会被 `bind` 和 `update` 调用

        let menulist = router.options.routes[1].children;
        binding.flag = false
        for (var i = 0; i < menulist.length; i++) {
            if (menulist[i].path == value.value) {
                binding.flag = true;
            } else {
                if (menulist[i].children && menulist[i].children.length > 0) {
                    for (var j = 0; j < menulist[i].children.length; j++) {
                        if (menulist[i].children[j].path == value.value) {
                            binding.flag = true;
                        }
                    }
                }
            }
        }
        if (binding.flag == true) {
            // el.style.display='block';
        } else {
            // console.log(el)
            el.style.display = 'none';
        }

    }
});

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'PcgqYDQsNaF43Om5eDN2RdwzOFdZVrcy'
})

router.beforeEach((to, from, next) => {
    if (sessionStorage.user) { //判断role 是否存在

        /* getmenu().then(res => {
            if (res.data.success == true) {
                sessionStorage.menu = JSON.stringify(res.data.result.menu);

                let menu = res.data.result.menu;
                // console.log(menu);
                menu.forEach(item => {
                    // 使用路由懒加载拼接路由路径获取组件
                    if (item.children && item.hasChildrenShow == 1) {
                        item.children.forEach(child => {
                            let route = {}
                            route.component = () =>
                                import (`@/components/${child.component}.vue`)
                            route.path = '/' + child.path;
                            route.meta = {
                                title: child.meta.title,
                                keepAlive: true
                            }
                            if (child.redirect) {
                                route.redirect = child.redirect
                            }
                            if (child.children && child.children.length > 0) { //子组件下有子组件  不被显示在菜单中，只在页面中切换
                                route.children = child.children;
                                child.children.forEach(childer => {
                                    childer.path = '/' + childer.path;
                                    let childcomponents = `components/${childer.component}.vue`;
                                    childer.component = () =>
                                        import (`@/${childcomponents}`)
                                })
                            }
                            route.routershow = child.hidden;
                            router.options.routes[1].children.push(route)
                        })
                    } else if (!item.children && item.hasChildrenShow != 1) {
                        let route = {}
                        route.path = '/' + item.path;
                        route.redirect = item.redirect;
                        route.meta = {
                            title: item.meta.title,
                            keepAlive: true
                        }
                        route.component = () =>
                            import (`@/components/${item.component}.vue`)
                        router.options.routes[1].children.push(route)
                    } else if (item.children && item.hasChildrenShow != 1) {
                        let route = {}
                        route.path = '/' + item.path;
                        route.redirect = item.redirect;
                        route.meta = {
                            title: item.meta.title,
                            keepAlive: true
                        }
                        route.children = item.children;
                        route.component = () =>
                            import (`@/components/${item.component}.vue`)
                        item.children.forEach(child => {
                            child.path = '/' + child.path;
                            child.meta = {
                                title: child.meta.title,
                                keepAlive: true
                            }
                            let childcomponents = `components/${child.component}.vue`;
                            child.component = () =>
                                import (`@/${childcomponents}`)
                        })

                        router.options.routes[1].children.push(route)
                    }
                })
                router.addRoutes(router.options.routes)
            }
        }) */
        next()
        return;
    } else {
        if (to.path == '/') {
            next();
            return;
        } else {
            next('/')
            return;
        }
    }
})

Vue.use(ViewUI);
Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        "inline": true,
        "button": true,
        "navbar": true,
        "title": true,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true,
        "keyboard": true,
    }
});

window.$vInstance = new Vue({
    router,
    render: h => h(App)
}).$mount('#app');